function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-24x24-Pay",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.5,1 C17.1568542,1 18.5,2.34314575 18.5,4 L18.5,4 L18.5,5 L19,5 C20.5976809,5 21.9036609,6.24891996 21.9949073,7.82372721 L22,8 L22,11 C23.1045695,11 24,11.8954305 24,13 L24,14 C24,15.1045695 23.1045695,16 22,16 L22,19 C22,20.6568542 20.6568542,22 19,22 L19,22 L4,22 C2.34314575,22 1,20.6568542 1,19 L1,19 L1,8 C1,6.34314575 2.34314575,5 4,5 L4,5 L4.5,5 L4.5,4 C4.5,2.40231912 5.74891996,1.09633912 7.32372721,1.00509269 L7.5,1 Z M19,7 L4,7 C3.44771525,7 3,7.44771525 3,8 L3,8 L3,19 C3,19.5522847 3.44771525,20 4,20 L4,20 L19,20 C19.5522847,20 20,19.5522847 20,19 L20,19 L20,16 L18.5,16 C17.1192881,16 16,14.8807119 16,13.5 C16,12.1192881 17.1192881,11 18.5,11 L20,11 L20,8 C20,7.48716416 19.6139598,7.06449284 19.1166211,7.00672773 L19,7 Z M15.5,3 L7.5,3 C6.94771525,3 6.5,3.44771525 6.5,4 L6.5,4 L6.5,5 L16.5,5 L16.5,4 C16.5,3.48716416 16.1139598,3.06449284 15.6166211,3.00672773 L15.6166211,3.00672773 L15.5,3 Z",
  id: "Combined-Shape",
  fill: "#60CAA8",
  fillRule: "nonzero"
}));

var SvgPay = function SvgPay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pay.efc2603b.svg";
export { ForwardRef as ReactComponent };